import { applyMiddleware, compose, createStore } from 'redux'

import { createLogger } from 'redux-logger'
import { reducers } from './reducers'
import { thunk } from 'redux-thunk' // v3.x usa named export

// add the middlewares
let middlewares = []

middlewares.push(thunk)

if (process.env.NODE_ENV !== 'production') {
  middlewares.push(createLogger())
}

// Use modern Redux DevTools API. Falls back to plain compose in production
// or when the extension isn't installed. The legacy `window.devToolsExtension`
// global was deprecated in Redux DevTools v3 (2018).
const composeEnhancers =
  (process.env.NODE_ENV !== 'production' &&
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) ||
  compose

const store = createStore(
  reducers,
  composeEnhancers(applyMiddleware(...middlewares)),
)

export { store }
